// extracted by mini-css-extract-plugin
export var container = "_df-0";
export var icon = "_df-1";
export var text = "_df-2";